import { API } from "aws-amplify";
import { useEffect, useContext, useState } from "react";
import { ApiName, READ_SEARCH, SET_SEARCH_WORD, RedminePath } from "../actions";
import AppContext from "../contexts/AppContext";

export const useSearch = () => {
  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [redmineUrl, setRedmineUrl] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [errors, setErrors] = useState({});

  const limit = 25;
  const generateQuery = (word = "", page = 1) => {
    word = word.replace(/\u3000/g, " "); // 全角スペースを半角スペースに変換
    let query = `?limit=${limit}`; // ページネーションで表示するチケットの件数。Redmineのデフォルトが25件のため25とする
    query += `&page=${page}`;
    query += `&issues=1`;
    query += `&q=${word}`;
    return { query };
  };

  useEffect(() => {
    setRedmineUrl(state.current.redmineurl);
    setApiKey(state.current.apikey);
  }, [state.current]);

  const readSearch = async (word = "", page = 1) => {
    dispatch({ type: SET_SEARCH_WORD, word });
    const conditions = generateQuery(word, page);
    try {
      setErrors({});
      if (loading !== true) setLoading(true);

      if (apiKey) {
        const myInit = {
          headers: { "Content-type": "application/json", "X-Api-Key": apiKey },
          queryStringParameters: {
            path: "search.json" + conditions.query,
            url: redmineUrl,
          },
        };
        API.get(ApiName, RedminePath, myInit)
          .then((response) => {
            dispatch({ type: READ_SEARCH, response });
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            setErrors({ api: err });
          });
        return "success";
      }
    } catch (err) {
      console.log("error");
      setErrors({ function: err });
    }
  };

  return {
    loading,
    setLoading,
    readSearch,
    errors,
  };
};
